/*
 * @Descripttion: 接口基本配置
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-09-24 17:36:18
 */
import sha1 from "utils/sha1";
const base = {
  request: "",
  upload: "",
  video: "",
  preRequest: "/cm-api",
  preRequestSz: "/sz-api",
};
switch (process.env.NODE_ENV) {
  case "development":
    base.requestSz = base.preRequestSz;
    base.request = base.preRequest;
    base.upload = "https://test-img4.nongji360.com";
    base.video = "https://datasp1.nongji360.com";
    break;
  case "test":
    base.request = "https://test-cm-api.datian360.com";
    base.upload = "https://test-img4.nongji360.com";
    base.video = "http://datasp1.nongji360.mobi";
    break;
  case "production":
    base.request = "/api";
    base.requestSz = base.preRequestSz;
    base.upload = "https://img4.nongji360.com";
    base.video = "https://datasp1.nongji360.com";
    base.pay = "/api";
    break;
}
/**
 * @descripttion: 接口固定参数
 * @Author: juanjuanhui
 * @Date: 2021-06-23 20:41:23
 * @return {Object} 固定参数
 */
const admParam = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  let timestamp = Math.floor(new Date().getTime() / 1000);
  if (!user) {
    user = { user_key: "", wui: "" };
  }
  return {
    bn: "140617.2",
    timestamp: timestamp,
    token: sha1.sha1("NJ360LoginAuth" + timestamp),
    terminal: 11,
    _origin: 7301,
    _uk: user.user_key,
    _wui: user.wui,
  };
};
export { base, admParam };
